(function () {
  'use strict';

  angular
    .module('app.sidebar', []);
})();
